import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';
import { NOTIFICATION_DISMISSION_STATUSES } from '../../constants';

const initialState = {
  data: [],
  error: null,
  isLoading: false
};

export default createReducer(initialState, {
  [c.GET_NOTIFICATIONS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),

  [c.GET_NOTIFICATIONS_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false
  }),

  [c.GET_NOTIFICATIONS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.DISMISS_NOTIFICATION_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),

  [c.DISMISS_NOTIFICATION_SUCCESS]: (state, { payload: { id } }) => ({
    ...state,
    data: state.data.map((notification) => ({
      ...notification,
      ...(id === notification.id && {
        status: NOTIFICATION_DISMISSION_STATUSES.DISMISS
      })
    })),
    isLoading: false
  }),

  [c.DISMISS_NOTIFICATION_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.READ_NOTIFICATION_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),

  [c.READ_NOTIFICATION_SUCCESS]: (state, { payload: { ids } }) => ({
    ...state,
    data: state.data.map((notification) => ({
      ...notification,
      ...(ids.includes(notification.id) && {
        status: NOTIFICATION_DISMISSION_STATUSES.READ
      })
    })),
    isLoading: false
  }),

  [c.READ_NOTIFICATION_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  })
});
